import { render, staticRenderFns } from "./ManageUsersGroupsEdit.vue?vue&type=template&id=0d03971d&scoped=true"
import script from "./ManageUsersGroupsEdit.vue?vue&type=script&lang=js"
export * from "./ManageUsersGroupsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03971d",
  null
  
)

export default component.exports